export default "ui-data{display:none}\n";